import { API_STATUS } from "../../../constants/apiStatus";

export const dailyUsageSliceInitialState = {
  dailyUsage: [],
  selectedDayUsage: null,
  apiStatus: {
    getDailyUsage: API_STATUS.IDLE,
    getDailyUsageByDate: API_STATUS.IDLE,
    createDailyUsage: API_STATUS.IDLE,
    updateDailyUsage: API_STATUS.IDLE,
  },
  error: null,
};
